import { pathOr } from 'ramda';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'src/store/ApplicationState';


export const useAccountManagement = () => {
  const authentication = useSelector(
    (state: ApplicationState) => state.authentication
  );

  const accountEmail = pathOr('', ['accountEmail'], authentication);
  const accountId = pathOr('', ['accountId'], authentication);
  const accountName = pathOr('', ['accountName'], authentication);
  const teamId = pathOr('', ['teamId'], authentication);
  const token = pathOr('', ['token'], authentication);
  return {
    teamId,
    token,
    accountEmail,
    accountId,
    accountName,
    authentication
  }
}


export const useApplicantManagement = () => {
  const authentication = useSelector(
    (state: ApplicationState) => state.authentication
  );
  const loanAppId = pathOr('', ['currentLoanRoleContext', 'loanAppId'], authentication);
  const applicantAccountId = pathOr('', ['applicantContext', 'accountId'], authentication);
  const applicantAccountEmail = pathOr('', ['applicantContext', 'accountEmail'], authentication);
  const applicantTeamId = pathOr('', ['applicantContext', 'teamId'], authentication);

  const loanRoleAccountId = pathOr(
    '',
    ['currentLoanRoleContext', 'loanRoleAccountId'],
    authentication
  );
  const loanRoleId = pathOr(
    '',
    ['currentLoanRoleContext', 'loanRoleId'],
    authentication
  );
  const loanAccountEmail = pathOr(
    '',
    ['currentLoanRoleContext', 'accountEmail'],
    authentication
  );
  const loanTeamId = pathOr('', ['currentLoanRoleContext', 'teamId'], authentication);
  const loanType = pathOr('', ['currentLoanRoleContext', 'loanType'], authentication);
  const loanProductType = pathOr('', ['currentLoanRoleContext', 'loanProductType'], authentication);


  return {
    loanAppId,
    applicantAccountId,
    applicantAccountEmail,
    applicantTeamId,
    loanRoleAccountId,
    loanRoleId,
    loanAccountEmail,
    loanTeamId,
    loanType,
    loanProductType
  };
};
